import { createAsyncThunk } from '@reduxjs/toolkit'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import { getAllLocations } from 'features/Location/services/location'
import {
  getDirectPutawayAPI,
  GetDirectPutawayResponseType,
} from 'features/PurchaseOrder/services/directPutaway'
import { callErrorMsg } from 'helpers/errorMsg'

export const SLICE_NAME = 'directPutawaySlice'

export const fetchGetLocations = createAsyncThunk(
  `${SLICE_NAME}/fetchGetLocations`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllLocations()

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetDirectPutaway = createAsyncThunk(
  `${SLICE_NAME}/fetchGetDirectPutaway`,
  async (params: Parameters<typeof getDirectPutawayAPI>[0], { getState, rejectWithValue }) => {
    try {
      const { directPutawayV2 } = getState() as StoreStateType

      const qs = { ...directPutawayV2.query, ...params }
      const cleanQs = Object.fromEntries(
        Object.entries(qs).filter(([_, v]) => v !== '' && v != null),
      )

      const res = await getDirectPutawayAPI(cleanQs)

      const result: GetDirectPutawayResponseType = {
        data: res.data.data,
        pagination: res.data.pagination,
      }

      return result
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
